import { useState } from 'react'

import { useSession } from '@/auth/session'

/**
 * Autenticado, porém sem permissões carregadas.
 *
 * É um estado real e distinto de "deslogado": o Cognito aceitou as credenciais e a
 * sessão existe, mas `GET /eu` não respondeu — ou respondeu 403 porque a conta não
 * está cadastrada na Administração (§5.1). Sem esta tela o usuário entraria numa
 * aplicação sem nenhum item de menu e sem nenhuma explicação, que é indistinguível
 * de um bug.
 *
 * Oferece as duas saídas que existem de verdade: tentar de novo, para a falha
 * transitória, e sair, para quando só um administrador pode resolver.
 */
export function SemPerfil() {
  const { erroDePerfil, recarregarPerfil, sair, sessao } = useSession()
  const [tentando, setTentando] = useState(false)

  async function tentarDeNovo() {
    setTentando(true)
    try {
      await recarregarPerfil()
    } finally {
      setTentando(false)
    }
  }

  return (
    <main className="bg-page flex min-h-dvh items-center justify-center px-6">
      <div className="rounded-field bg-surface-card border-border-subtle w-full max-w-lg border p-8">
        <h1 className="text-text-body type-h2">Não foi possível liberar seu acesso</h1>

        <p role="alert" className="text-text-body mt-4 type-body">
          {erroDePerfil?.mensagem}
        </p>

        {/* O e-mail é o dado que o administrador precisa para achar a conta — mostrá-lo
            aqui poupa o usuário de adivinhar com qual endereço ele entrou. */}
        {sessao ? (
          <p className="text-text-muted mt-2 type-sm">Você entrou como {sessao.email}.</p>
        ) : null}

        <div className="mt-8 flex flex-wrap gap-3">
          {/* 🔒 Só quando repetir pode funcionar. Falta de cadastro e endereço ausente
              em `config.json` dão o MESMO resultado na segunda tentativa — oferecer o
              botão nesses casos convida o usuário a repetir um gesto inútil e a
              concluir que errou alguma coisa. */}
          {erroDePerfil?.podeTentarNovamente ? (
            <button
              type="button"
              onClick={() => void tentarDeNovo()}
              disabled={tentando}
              className="rounded-control bg-action-primary text-action-primary-fg hover:bg-action-primary-hover disabled:bg-action-disabled disabled:text-action-disabled-fg px-6 py-3 type-button transition-colors duration-base ease-out"
            >
              {tentando ? 'Tentando…' : 'Tentar de novo'}
            </button>
          ) : null}

          <button
            type="button"
            onClick={() => void sair()}
            className="rounded-control border-border-subtle text-text-body border px-6 py-3 type-button"
          >
            Sair
          </button>
        </div>
      </div>
    </main>
  )
}
